import React, { FunctionComponent } from "react";
import "./PassionFriday.scss";

export const PassionFriday: FunctionComponent = () => (
  <main className="passion-friday">
    <h1>Glad Passion Friday!</h1>
    <p>Nyfikenhet på schemat</p>
    <img src="/passion.webp" alt="Passion fruit" />
  </main>
);
